import { VerticalSynchronizedCrosshair } from '../../../core/components/shared-chart-interactions/components/VerticalSynchronizedCrosshair.js';
import { useSynchronizedCrosshair } from '../../../core/components/shared-chart-interactions/hooks/useSynchronizedCrosshair.js';
import { useSyncedXScaleByPriority } from '../../hooks/useSyncedXScaleByPriority.js';
import { useXYChartId } from '../../hooks/useXYChartId.js';

export function XYChartSynchronizedCrosshair() {
  const synchronizedCrosshair = useSynchronizedCrosshair();
  const chartId = useXYChartId();
  const syncedXScale = useSyncedXScaleByPriority();

  if (!synchronizedCrosshair) {
    return null;
  }

  const { hoveredChartId, disabled: synchronizedCrosshairDisabled } =
    synchronizedCrosshair;

  const showVerticalCrosshair =
    hoveredChartId !== chartId && !synchronizedCrosshairDisabled;

  if (!(showVerticalCrosshair && syncedXScale)) {
    return null;
  }

  return <VerticalSynchronizedCrosshair scale={syncedXScale} />;
}

XYChartSynchronizedCrosshair['displayName'] = 'XYChartSynchronizedCrosshair';
